import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('line_items'),
    subtitle: defineMessage('available_tables_in_the_request'),
    optionAll: defineMessage('both_category_and_item_details_tables'),
    optionAccountBasedLines: defineMessage('category_details_table'),
    optionItemBasedLines: defineMessage('item_details_table'),
};
